/**
 * ID of HTML DIV element which contains the feedback dialog
 */
export const feedbackContainerId = "reflag-feedback-dialog-container";
export const toolbarContainerId = "reflag-toolbar-dialog-container";

/**
 * These events will be propagated to the feedback dialog
 *
 * @see [https://developer.mozilla.org/en-US/docs/Web/API/Element#events](https://developer.mozilla.org/en-US/docs/Web/API/Element#events)
 */
export const propagatedEvents = [
  "animationcancel",
  "animationend",
  "animationiteration",
  "animationstart",
  "afterscriptexecute",
  "auxclick",
  "beforescriptexecute",
  "blur",
  "click",
  "compositionend",
  "compositionstart",
  "compositionupdate",
  "contextmenu",
  "copy",
  "cut",
  "dblclick",
  "DOMActivate",
  "DOMMouseScroll",
  "error",
  "focusin",
  "focusout",
  "focus",
  "fullscreenchange",
  "fullscreenerror",
  "gesturechange",
  "gestureend",
  "gesturestart",
  "gotpointercapture",
  "keydown",
  "keypress",
  "keyup",
  "lostpointercapture",
  "mousedown",
  "mouseenter",
  "mouseleave",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "mousewheel",
  "paste",
  "pointercancel",
  "pointerdown",
  "pointerenter",
  "pointerleave",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "scroll",
  "select",
  "touchcancel",
  "touchend",
  "touchmove",
  "touchstart",
  "transitioncancel",
  "transitionend",
  "transitionrun",
  "transitionstart",
  "wheel",
];
